"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const TokenBucketBasedRateLimiter_1 = __importDefault(require("./TokenBucketBasedRateLimiter"));
const TokenBucketImplFactory_1 = __importDefault(require("./TokenBucketImplFactory"));
const TokenBucketRefillerImplFactory_1 = __importDefault(require("./TokenBucketRefillerImplFactory"));
class TokenBucketBasedRateLimiterFactory {
    static create(capacity, tokenRefillStrategy) {
        const tokenBucket = TokenBucketImplFactory_1.default.create(capacity);
        return new TokenBucketBasedRateLimiter_1.default(tokenBucket, TokenBucketRefillerImplFactory_1.default.create(tokenRefillStrategy, tokenBucket));
    }
}
exports.default = TokenBucketBasedRateLimiterFactory;
